var React = require( 'react' );
var createReactClass = require('create-react-class');
var PropTypes = require('prop-types');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var PlayList = createReactClass({
	mixins: [PureRenderMixin],

	getDefaultProps: function(){
		return {
			gender: "male"
		}
	},

	getVideoUrl: function() {
		var playlistID = (this.props.gender === 'female') ? this.props.video.female_playlist : this.props.video.male_playlist;
		var url = '//fast.wistia.net/embed/playlists/' + playlistID + '?bento%5BmenuPosition%5D=bottom&media_0_0%5BautoPlay%5D=false&media_0_0%5BcontrolsVisibleOnLoad%5D=false&theme=bento&version=v1&videoOptions%5BautoPlay%5D=true&videoOptions%5BplayerColor%5D=0a0a0a&videoOptions%5BvideoHeight%5D=360&videoOptions%5BvideoWidth%5D=640&videoOptions%5BvolumeControl%5D=true';
		return url;
	},

	componentDidMount: function() {
		var video, wrapper;
		wrapper = document.createElement('div');
		wrapper.innerHTML = '<iframe src="' + this.getVideoUrl() + '" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_playlist" name="wistia_playlist" allowfullscreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen></iframe>'
		video = wrapper.firstChild;
		this.refs.target.appendChild(video);
	},

	render: function(){
		return (
			<div className="video-container">
				<div id="video" className="flex-video" ref="target"></div>
			</div>
		)
	}
});

PlayList.propTypes = {
  gender: PropTypes.string
};

module.exports = PlayList;


// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/playList.jsx